export const allOrganizationsSelector = () => state => Object.values(state.organizations);
export const organizationSelector = (organizationKey) => state => {
    if (!Boolean(organizationKey)) {
        return null;
    }

    return state.organizations[organizationKey];
};